
    import {
        defineComponent, PropType, toRefs, unref, computed,
    } from 'vue';
    import moment from 'moment';
    import { formatNumber, wordEnding } from '@ve/services/textModifiers';

    import ButtonV from '@ve/components/button/desktop/Button.vue';
    import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';
    import { useState } from 'vuex-composition-helpers';
    import { NAMESPACE as SERP_PAGE_STATE_STORE } from '@ve/pages/serp/store/serpPageStateStore';
    import { THotelCardRightBlock } from './types/index';

    export default defineComponent({
        name: 'search-page-hotel-card-right-block',
        components: {
            HintTooltip,
            ButtonV,
        },
        props: {
            hotelCardRightBlockData: {
                type: Object as PropType<THotelCardRightBlock>,
                required: true,
            },
        },
        setup(props) {
            const {
                hotelCardRightBlockData,
            } = toRefs(props);

            const {
                minutesAfterSearchStarted,
            } = useState(SERP_PAGE_STATE_STORE, ['minutesAfterSearchStarted']);

            const adults = computed(() => unref(hotelCardRightBlockData).touristGroup.adults);
            const kids = computed(() => unref(hotelCardRightBlockData).touristGroup.kids);
            const infants = computed(() => unref(hotelCardRightBlockData).touristGroup.infants);
            const checkInDateFormatted = computed(() => moment(unref(hotelCardRightBlockData).checkInDate, 'YYYY-MM-DD').format('DD MMMM'));
            const nights = computed(() => unref(hotelCardRightBlockData).nights);
            const kidsAndInfantsSum = computed(() => unref(kids) + unref(infants));

            const priceText = computed(() => `от ${formatNumber(unref(hotelCardRightBlockData).priceWithOilTax)}`);
            const timerText = computed(() => `цена ${unref(minutesAfterSearchStarted)} минут${wordEnding(unref(minutesAfterSearchStarted), 'у;ы;')} назад`);
            const touristGroupAdultsText = computed(() => `${unref(adults)} взросл${wordEnding(unref(adults), ('ый;ых;ых'))}`);
            const touristGroupKidsText = computed(() => `и ${unref(kidsAndInfantsSum)} ${wordEnding(unref(kidsAndInfantsSum), ('ребенок;детей;детей'))}`);
            const touristGroupInfantsText = computed(() => `и ${unref(infants)} ${wordEnding(unref(infants), ('младенец;младенца;младенца'))}`);
            const dateText = computed(() => `c ${unref(checkInDateFormatted)} на ${unref(nights)} ноч${wordEnding(unref(nights), ('ь;и;ей;'))}`);

            return {
                touristGroup: unref(hotelCardRightBlockData).touristGroup,
                priceText,
                timerText,
                minutesAfterSearchStarted,
                touristGroupAdultsText,
                touristGroupKidsText,
                touristGroupInfantsText,
                dateText,
            };
        },
    });
